
window.addEventListener('DOMContentLoaded', () => {
    //Get UTM Parameters
    const checkUTMParams = JSON.parse(localStorage.getItem('utm_params'));
    if (!checkUTMParams) {
        const url_string = window.location.href
        let url = new URL(url_string);
        const utm_campaign = url.searchParams.get("utm_campaign");
        const utm_content = url.searchParams.get("utm_content");
        const utm_medium = url.searchParams.get("utm_medium");
        const utm_source = url.searchParams.get("utm_source");
        const utm_term = url.searchParams.get("utm_term");

        const data = {
            'utm_campaign': `${utm_campaign}`,
            'utm_content': `${utm_content}`,
            'utm_medium': `${utm_medium}`,
            'utm_source': `${utm_source}`,
            'utm_term': `${utm_term}`
        }
        localStorage.setItem('utm_params', JSON.stringify(data));
    }

       //Free Gift Beauty Bath Bar - Calming
        var codeCookieValue;
        var getCookie = function (name) {
            var value = "; " + document.cookie;
            var parts = value.split('; ' + name + '=');
            if (parts.length == 2) return parts.pop().split(";").shift();
        };

        codeCookieValue = getCookie('discount_code');

        if (codeCookieValue == "PD23") {
            const banner = document.querySelector('.announcement__text');
            banner.innerText = "PD23: Your FREE Gift auto applies when you Choose 3 boxes of Shameless";
        }
});

function getCollabButton() {
    const dovetaleContainer = document.querySelector('#dovetale-container');
    dovetaleContainer.style.display = 'block';
    const btniframe = document.querySelector('#dovetale-container iframe');
    const btndovelate = btniframe.contentWindow.document.querySelector('.dovetale-button');
    btndovelate.click();
}

function openChatWidget() {
        GorgiasChat.open();
        setTimeout(() => {
            const btn = document.querySelector('.gorgias-chat-key-eam2gc');
            btn.style.display = "block";
        }, 100);
      var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});

    initGorgiasChatPromise.then(async function() {
    var chatElem = document.getElementById("gorgias-chat-container");
    chatElem.style.display = "";
    });
}





